import { Component, Input, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OrderTypeSummaries } from "src/app/shared/models/focusDataModels/OrderTypeSummaries";

@Component({
	selector: "app-order-type-comparison-chart",
	templateUrl: "./order-type-comparison-chart.component.html",
	styleUrls: ["./order-type-comparison-chart.component.scss"],
})
export class OrderTypeComparisonChartComponent implements OnInit {
	@Input() orderTypeSummaries: OrderTypeSummaries[];

	chartOptions = {
		legend: {
			display: true,
		},
		responsive: true,
		hover: {
			mode: "index",
		},
	};

	chartData = {
		labels: undefined,
		datasets: undefined,
	};

	constructor(public app: AppService) {}

	ngOnInit(): void {
		this.buildChart();
	}

	buildChart() {
		const color = this.app.references.pastelColorGenerator(1);
		const otId: {
			id: number;
			name: string;
			totalSales: number;
		}[] = [];
		for (let ot of this.orderTypeSummaries) {
			const idx = otId.findIndex((i) => i.id === ot.ID);
			if (idx === -1) {
				otId.push({
					id: ot.ID,
					name: ot.OrderType.Name,
					totalSales: +(Math.round(ot.OTSales * 100) / 100).toFixed(2),
				});
			} else {
				otId[idx].totalSales += +(Math.round(ot.OTSales * 100) / 100).toFixed(2);
			}
		}

		this.chartData.labels = otId.map((i) => i.name);
		const data = {
			label: "Order Type Sales",
			backgroundColor: color[0],
			data: otId.map((i) => i.totalSales),
		};
		this.chartData.datasets = [data];
	}
}
